import { AxiosError } from "axios";
import { api } from "../../api/api";
import Pageable from "../../model/page/Pageable";
import Page from "../../model/page/Page";
import Usuario from "../../model/Usuario";
import { getFilters } from "../../utils/filterUtils";
import { DataTableFilterMeta } from "primereact/datatable";

export default class UsuarioService {
    pesquisar(pageable: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/usuario`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: pageable.page,
                size: pageable.size,
                sort: pageable.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisarSienge(pageable: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/usuario/sienge`;
            const params = {
                page: pageable.page,
                size: pageable.size,
                sort: pageable.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarTodos() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            let url = `/usuario/all`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscar(id: number) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/${id}`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    inserirPeloCpf(cpf: string) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/cpf/${cpf}`;
            api
                .post(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    inserirPeloCnpj(cnpj: string) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/cnpj/${cnpj}`;
            api
                .post(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    resetarSenha(id: number) {
        return new Promise<Usuario>((resolve, reject): void => {
            let url = `/usuario/resetarSenha/${id}`;
            api
                .post(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerarLinkTrocaSenha(id: number) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/usuario/linkTrocaSenha/${id}`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}